// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1sPUb","subheader":"ReorderModal_subheader__3sWPB","listWrap":"ReorderModal_listWrap__tWbft"};